import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { LOGO } from "../lib/api";
import { toast } from "sonner";
import { useI18n } from "../lib/LanguageContext";

export function LoginPage() {
  const { t } = useI18n();
  const { login } = useAuth(); const nav = useNavigate();
  const [email, setEmail] = useState(""); const [pw, setPw] = useState(""); const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(email, pw); toast.success(t("auth.welcome")); nav("/nuna"); }
    catch (err) { toast.error(err.response?.data?.detail || t("auth.login_failed")); }
    finally { setLoading(false); }
  };
  return (
    <AuthShell title={t("auth.login_title")} testId="login-page">
      <form onSubmit={submit} className="space-y-4">
        <div><Label>Email</Label><Input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="login-email"/></div>
        <div><Label>{t("auth.password")}</Label><Input type="password" required value={pw} onChange={(e)=>setPw(e.target.value)} data-testid="login-password"/></div>
        <Button type="submit" disabled={loading} className="w-full rounded-full bg-teal hover:bg-teal/90 text-white h-11" data-testid="login-submit">{loading?t("auth.processing"):t("auth.login")}</Button>
      </form>
      <p className="mt-6 text-sm text-center text-muted-foreground">{t("auth.no_account")} <Link to="/daftar" className="text-teal font-semibold">{t("auth.register")}</Link></p>
    </AuthShell>
  );
}

export function RegisterPage() {
  const { t } = useI18n();
  const { register } = useAuth(); const nav = useNavigate();
  const [f, setF] = useState({ full_name:"", email:"", password:"", profession:"individual" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await register(f); toast.success(t("auth.account_created")); nav("/nuna"); }
    catch (err) { toast.error(err.response?.data?.detail || t("auth.register_failed")); }
    finally { setLoading(false); }
  };
  return (
    <AuthShell title={t("auth.register_title")} testId="register-page">
      <form onSubmit={submit} className="space-y-4">
        <div><Label>{t("auth.name")}</Label><Input required value={f.full_name} onChange={(e)=>setF({...f, full_name:e.target.value})} data-testid="register-name"/></div>
        <div><Label>Email</Label><Input type="email" required value={f.email} onChange={(e)=>setF({...f, email:e.target.value})} data-testid="register-email"/></div>
        <div><Label>{t("auth.password")}</Label><Input type="password" required minLength={6} value={f.password} onChange={(e)=>setF({...f, password:e.target.value})} data-testid="register-password"/></div>
        <div><Label>{t("auth.profession")}</Label>
          <select value={f.profession} onChange={(e)=>setF({...f, profession:e.target.value})} className="mt-2 w-full border border-input rounded-md h-10 px-3 text-sm bg-white" data-testid="register-profession">
            <option value="individual">{t("auth.individual")}</option><option value="student">{t("auth.student")}</option>
            <option value="lecturer">{t("auth.lecturer")}</option><option value="researcher">{t("auth.researcher")}</option>
            <option value="doctor">{t("auth.doctor")}</option><option value="health_worker">{t("auth.health_worker")}</option>
          </select>
        </div>
        <Button type="submit" disabled={loading} className="w-full rounded-full bg-teal hover:bg-teal/90 text-white h-11" data-testid="register-submit">{loading?t("auth.processing"):t("auth.register")}</Button>
      </form>
      <p className="mt-6 text-sm text-center text-muted-foreground">{t("auth.has_account")} <Link to="/masuk" className="text-teal font-semibold">{t("auth.login")}</Link></p>
    </AuthShell>
  );
}

function AuthShell({ title, children, testId }) {
  return (
    <div className="min-h-[calc(100vh-80px)] hero-bg flex items-center justify-center py-12 px-6" data-testid={testId}>
      <div className="w-full max-w-md bento-tile p-8 shadow-xl">
        <div className="flex justify-center mb-6"><img src={LOGO} alt="GIDZA" className="h-12"/></div>
        <h1 className="font-display text-3xl font-medium text-center mb-6">{title}</h1>
        {children}
      </div>
    </div>
  );
}
